import React from 'react'
import { Modal } from 'components'
import img_recruit from 'assets/img/recruit.png'

const RecruitModal = () => {
    return (
        <Modal
            id='recruit-modal'
            title='募集達人'
            html={
                <div>
                    <img src={img_recruit} alt='recruit'/>
                    
                    <div>
                        <p>
                            <span role='img' aria-label='rocket'>🚀</span> 立即加入優分析合作夥伴計劃，開啟收入新機會！
                        </p>
                        
                        <p>
                            無論你是投資達人、自媒體創作者、YouTuber，還是我們長期支持的朋友，只要透過文章或影片介紹**「優分析產業數據庫」**，就能輕鬆賺取額外收入！
                        </p>

                        <p>
                            <span role='img' aria-label='lightbulb'>💡</span> 擅長基本面分析或有合作點子嗎？立即與我們聯繫！
                        </p>

                        <p>
                            <span role='img' aria-label='key'>🔑</span> 現在就行動，讓你的影響力變現，把專業知識轉換為最大價值！
                        </p>
                        
                        <p>
                            <span role='img' aria-label='email'>📩</span> 聯繫我們:<a href='mailto:pr@uanalyze.com.tw'>
                                    pr@uanalyze.com.tw</a>
                        </p>

                        <p>
                            <span role='img' aria-label='phone'>📞</span> 或撥打<a href='tel:02-2747-3447'>
                                    (02)2747-3447</a>分機803,立即展開合作！
                        </p>
                    </div>
                </div>
            }
            leaveTxt = '我知道了'
        />
    );
}


export { RecruitModal }
